import React, { lazy } from "react";
import { Route, Switch } from "react-router-dom";
import { AUTO_LOANS_APPLICATION_FORM } from "./paths";
const LoansLanding = lazy(() => import("Components/Loans/LoansLanding"));
const LoanInner = lazy(() => import("Components/Loans/LoanInner"));
const AutoThankYou = lazy(() =>
  import("Components/ThankYouPages/AutoThankYou")
);
const AutoLoanApplicationForm = lazy(() => import("pages/Forms/AutoLoan"));
const PLThankYou = lazy(() => import("Components/ThankYouPages/PLThankYou"));
const HLThankYou = lazy(() => import("Components/ThankYouPages/HLThankYou"));
const LoansRoutes = () => {
  return (
    <Switch>
      <Route
        path={AUTO_LOANS_APPLICATION_FORM}
        component={AutoLoanApplicationForm}
      />
      <Route path="/loans/personalloans/thankyou" component={PLThankYou} />
      <Route path="/loans/homeloans/thankyou" component={HLThankYou} />
      <Route path="/loans/autoloans/thankyou" component={AutoThankYou} />

      <Route path="/loans/:id" component={LoanInner} />
      <Route path="/loans" component={LoansLanding} />
    </Switch>
  );
};

export default LoansRoutes;
